import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faClipboard, faChartLine, faHeartbeat, faLightbulb, faShieldAlt, faStar } from '@fortawesome/free-solid-svg-icons';
import { Modal } from './Modal';
import './HelpModal.css';

export const TeamHelpModal: React.FC<{ isOpen: boolean; onClose: () => void; }> = ({ isOpen, onClose }) => (
    <Modal isOpen={isOpen} onClose={onClose} className="help-modal">
        <h2><FontAwesomeIcon icon={faUsers} style={{ marginRight: '8px', color: 'var(--positive-color)' }} />Squad Guide</h2>
        <p style={{ fontSize: '1.1em', marginBottom: '24px' }}>Manage your squad and monitor player performance. Here's what you need to know:</p>

        <div className="help-section">
            <h3><FontAwesomeIcon icon={faClipboard} style={{ marginRight: '8px', color: 'var(--info-color)' }} />Squad List Tab</h3>
            <p><strong>View all your players with:</strong></p>
            <ul style={{ marginLeft: '20px', marginTop: '8px' }}>
                <li><strong>Position:</strong> GK, DEF, MID, FWD</li>
                <li><strong>Skill:</strong> Overall ability (0-99)</li>
                <li><strong>Potential:</strong> Maximum skill reachable</li>
                <li><strong>Age:</strong> Player's current age</li>
                <li><strong>Value:</strong> Current market value</li>
                <li><strong>Status:</strong> Starting XI or Reserve</li>
            </ul>
            <p className="help-tip"><FontAwesomeIcon icon={faLightbulb} style={{ marginRight: '6px', color: 'var(--warning-color)' }} /><em>Click a player to view detailed profile and make decisions</em></p>
        </div>

        <div className="help-section">
            <h3><FontAwesomeIcon icon={faShieldAlt} style={{ marginRight: '8px', color: 'var(--accent-text-color)' }} />Squad Depth Tab</h3>
            <p><strong>What you see:</strong> Formation visualization showing your starting XI in their positions.</p>
            <ul style={{ marginLeft: '20px', marginTop: '8px' }}>
                <li>Visual pitch layout of your team</li>
                <li>Player names and positions</li>
                <li>Quick assessment of tactical shape</li>
            </ul>
            <p className="help-tip"><FontAwesomeIcon icon={faLightbulb} style={{ marginRight: '6px', color: 'var(--warning-color)' }} /><em>Check depth - ensure you have backups at all positions</em></p>
        </div>

        <div className="help-section">
            <h3><FontAwesomeIcon icon={faHeartbeat} style={{ marginRight: '8px', color: 'var(--negative-color)' }} />Morale Tab</h3>
            <p><strong>See unhappy players:</strong> Players with morale issues that need attention.</p>
            <ul style={{ marginLeft: '20px', marginTop: '8px' }}>
                <li><strong>Unhappy/Furious:</strong> Below expectations (drops performance)</li>
                <li><strong>Reason:</strong> Why they're upset (bench, low wages, etc.)</li>
                <li><strong>Wants to Talk:</strong> Player requesting a meeting</li>
            </ul>
            <p className="help-tip"><FontAwesomeIcon icon={faLightbulb} style={{ marginRight: '6px', color: 'var(--warning-color)' }} /><em>Talk to unhappy players or improve wages to boost morale</em></p>
        </div>

        <div className="help-section">
            <h3><FontAwesomeIcon icon={faChartLine} style={{ marginRight: '8px', color: 'var(--warning-color)' }} />Fixtures Tab</h3>
            <p><strong>Upcoming matches:</strong> Schedule for the next several weeks.</p>
            <ul style={{ marginLeft: '20px', marginTop: '8px' }}>
                <li>Date and opponent</li>
                <li>Home or away fixture</li>
                <li>League or cup competition</li>
            </ul>
            <p className="help-tip"><FontAwesomeIcon icon={faLightbulb} style={{ marginRight: '6px', color: 'var(--warning-color)' }} /><em>Plan your squad rotation around difficult fixtures</em></p>
        </div>

        <div className="help-section">
            <h3><FontAwesomeIcon icon={faStar} style={{ marginRight: '8px', color: 'var(--info-color)' }} />Team Overview Panel</h3>
            <p><strong>Key metrics about your squad:</strong></p>
            <ul style={{ marginLeft: '20px', marginTop: '8px' }}>
                <li><strong>Average Skill:</strong> Combined player abilities</li>
                <li><strong>Squad Value:</strong> Total market value of all players</li>
                <li><strong>Average Age:</strong> Median player age</li>
                <li><strong>Morale:</strong> Team morale average</li>
                <li><strong>Fitness:</strong> Average fitness level (aim for 60+)</li>
                <li><strong>Injuries:</strong> Number of injured players</li>
            </ul>
        </div>

        <div className="help-section">
            <h3><FontAwesomeIcon icon={faShieldAlt} style={{ marginRight: '8px', color: 'var(--positive-color)' }} />Strategy Tips</h3>
            <ul style={{ marginLeft: '20px', marginTop: '8px' }}>
                <li>Rotate squad on easy weeks to maintain fitness</li>
                <li>Monitor injuries - replace with backups immediately</li>
                <li>Address morale issues before they snowball</li>
                <li>Keep 2-3 players at each position for depth</li>
                <li>Balance squad with mix of youth (development) and veterans (experience)</li>
                <li>Use reserves in cup matches to preserve fitness</li>
            </ul>
        </div>

        <div className="modal-actions">
            <button className="button primary" onClick={onClose}>Got it!</button>
        </div>
    </Modal>
);
